//**********************在线培训前台****************************

import * as httpHelper from '../httpHelper'; //网络助手


//六枝在线学习首页
export function trainingIndex() {
  return httpHelper.get('trainingIndex')
}

//用户获取分类列表
export function cloudGetCourseClass(params) {
  return httpHelper.get('cloudGetCourseClass',params)
}

//用户获取科目列表
export function getSubjectList(params) {
  return httpHelper.get('getSubjectList',params)
}

//获取培训详情
export function CloudGetTrainigInfoById(params) {
  return httpHelper.get('getTrainigInfoById',params)
}

//获取培训列表
export function getTrainingList(params) {
  return httpHelper.get('getTrainingList',params)
}

//加入课程
export function joinCourse(params) {
  return httpHelper.post('joinCourse',params)
}

//退出课程
export function exitCourse(params) {
  return httpHelper.post('exitCourse',params)
}

//开始学习
export function startStudy(params) {
  return httpHelper.post('startStudy',params,false)
}

//更新学习时间
export function updateStudyTime(params) {
  return httpHelper.post('updateStudyTime',params)
}


//************************考试-测验***************************

//用户提交章节测验答案
export function getExamList(params) {
  return httpHelper.post('getExamList',params)
}

//用户提交章节测验答案
export function submitSectionTest(params) {
  	return httpHelper.postJson('submitSectionTest',params)
}

//开始考试
export function startExam(params) {
	return httpHelper.post('startExam',params)
}

//提交单个考试题目答案
export function submitExamSubjectAnswer(params) {
  	return httpHelper.postJson('submitExamSubjectAnswer',params)
}

//提交重做答案
export function submitRedoSubjectAnswer(params) {
  return httpHelper.post('submitRedoSubjectAnswer',params)
}


//提交试卷
export function submitExamPaper(params) {
  	return httpHelper.post('submitExamPaper',params)
}

//根据用户考试ID获取考试详情
export function getUserExamDetailInfo(params) {
  	return httpHelper.get('getUserExamDetailInfo',params)
}

//根据考试/测验ID获取测验/考试 试卷详情
export function getExamPaperDetailInfoById(params) {
  return httpHelper.get('getExamPaperDetailInfoById',params)
}


//获取我的培训列表
export function getMyTrainingList(params) {
  return httpHelper.get('getMyTrainingList',params)
}

//***************************其它**********************************

//机构黑白名单
export function getOrgInfoList(params) {
  return httpHelper.get('getOrgInfoList',params)
}

//==============4.30课堂=============
//获取课程列表
export function getCourseList(params) {
  return httpHelper.get('getCourseList',params)
}
